<template>
  <div>
    <!-- Step 1: DO Reference Input -->
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">DO Reference</label>
        <vs-input
          class="w-full"
          v-model="doReference"
          placeholder="Enter DO reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="doReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <!-- Step 2: Preview Table (grouped by product_id) -->
    <div class="vx-row mt-6" v-if="showPreview">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">DO Details — Pilih product untuk Cancel GI Partial</span>
          </div>
          <div class="cgip-table-wrap">
            <table class="cgip-table">
              <thead>
                <tr>
                  <th>PRODUCT</th>
                  <th>WAREHOUSE</th>
                  <th class="cgip-num">QTY</th>
                  <th class="cgip-num">PICKED QTY</th>
                  <th class="cgip-num">OPEN QTY</th>
                  <th class="cgip-action">ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(group, index) in groupedDetails"
                  :key="group.product_id"
                  :class="{ 'cgip-row-last': index === groupedDetails.length - 1 }"
                >
                  <td>
                    <span class="cgip-product-name">{{ group.product }}</span>
                  </td>
                  <td>
                    <span class="cgip-warehouse">{{ group.warehouses }}</span>
                  </td>
                  <td class="cgip-num">{{ group.totalQty }}</td>
                  <td class="cgip-num">{{ group.totalPickedQty }}</td>
                  <td class="cgip-num">{{ group.totalOpenQty }}</td>
                  <td class="cgip-action">
                    <vs-button
                      color="danger"
                      type="border"
                      size="small"
                      class="cgip-cancel-btn"
                      @click="openCancelModal(group)"
                    >
                      Cancel
                    </vs-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vs-card>
      </div>
    </div>

    <!-- Step 3: Cancel Modal -->
    <vs-popup
      :title="'Cancel GI Partial — ' + (selectedGroup ? selectedGroup.product : '')"
      :active.sync="showCancelModal"
      v-if="selectedGroup"
    >
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference</td>
          <td style="padding:4px 0;">{{ doReference }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">Product</td>
          <td style="padding:4px 0;">{{ selectedGroup.product }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">Warehouse</td>
          <td style="padding:4px 0;">{{ selectedGroup.warehouses }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">Available Qty</td>
          <td style="padding:4px 0;">{{ selectedGroup.totalQty }}</td>
        </tr>
      </table>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <label class="vs-input--label pl-1">Qty to Cancel</label>
          <vs-input
            class="w-full"
            type="number"
            v-model="cancelQty"
            ref="cancelQtyInput"
          />
        </div>
      </div>

      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showCancelModal = false">Batal</vs-button>
        <vs-button color="danger" class="btn" @click="confirmCancel" :disabled="isSubmitting">Process</vs-button>
      </div>
    </vs-popup>

    <!-- Step 4: Result -->
    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Cancel GI Partial</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/4" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:13px;font-weight:600;">PRODUCT</span>
            </div>
            <div class="vx-col md:w-1/4" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:13px;font-weight:600;">CANCELLED QTY</span>
            </div>
            <div class="vx-col md:w-1/4" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:13px;font-weight:600;">INVENTORIES CREATED</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:13px;font-weight:600;">TX DELETED / UPDATED</span>
            </div>
          </div>
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/4" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.product_code }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.cancelled_qty }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.inventories_created }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.transactions_deleted || result.transactions_updated }}</span>
            </div>
          </div>
          <div class="vx-row" style="background:#f0f0f0;">
            <div class="vx-col w-full" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Outbound Details Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.outbound_details_updated }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelGiPartial",
  data() {
    return {
      doReference: "",
      details: [],
      showPreview: false,
      showCancelModal: false,
      selectedGroup: null,
      cancelQty: "",
      isSubmitting: false,
      result: null,
    };
  },
  computed: {
    groupedDetails() {
      var map = {};
      this.details.forEach(function (d) {
        if (!map[d.product_id]) {
          map[d.product_id] = {
            product_id: d.product_id,
            product: d.product,
            warehouses: [],
            totalQty: 0,
            totalPickedQty: 0,
            totalOpenQty: 0,
          };
        }
        var g = map[d.product_id];
        if (d.warehouse && g.warehouses.indexOf(d.warehouse) === -1) {
          g.warehouses.push(d.warehouse);
        }
        g.totalQty += parseFloat(d.qty) || 0;
        g.totalPickedQty += parseFloat(d.picked_qty) || 0;
        g.totalOpenQty += parseFloat(d.open_qty) || 0;
      });
      return Object.keys(map).map(function (k) {
        var g = map[k];
        g.warehouses = g.warehouses.join(", ");
        return g;
      });
    },
  },
  methods: {
    searchPreview() {
      if (this.doReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "DO Reference is required",
        });
        return false;
      }

      this.$emit("loading", true);
      this.showPreview = false;
      this.result = null;

      this.$http
        .post("support/outbound/deliveryorder/preview-do-item", {
          do_reference: this.doReference,
        })
        .then((res) => {
          this.details = res.data.data.details;
          this.showPreview = true;
          this.$emit("loading", false);
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },

    openCancelModal(group) {
      this.selectedGroup = group;
      this.cancelQty = "";
      this.showCancelModal = true;
      this.$nextTick(() => {
        if (this.$refs.cancelQtyInput) {
          var input = this.$refs.cancelQtyInput.$el
            ? this.$refs.cancelQtyInput.$el.querySelector("input")
            : null;
          if (input) input.focus();
        }
      });
    },

    confirmCancel() {
      var qty = parseFloat(this.cancelQty);
      var maxQty = parseFloat(this.selectedGroup.totalQty);

      if (!qty || qty <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Qty to Cancel harus lebih dari 0",
        });
        return;
      }

      if (qty > maxQty) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Qty to Cancel tidak boleh lebih dari " + maxQty,
        });
        return;
      }

      this.showCancelModal = false;
      this.isSubmitting = true;
      this.$emit("loading", true);

      this.$http
        .post("support/outbound/deliveryorder/cancel-gi-partial", {
          do_reference: this.doReference,
          product_id: this.selectedGroup.product_id,
          qty: qty,
        })
        .then((res) => {
          this.result = res.data.data;
          this.isSubmitting = false;
          this.$emit("loading", false);
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: res.data.message || "Cancel GI Partial berhasil diproses.",
          });
          // Refresh table dengan data terbaru
          this.searchPreview();
        })
        .catch((error) => {
          this.isSubmitting = false;
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
  },
};
</script>

<style scoped>
/* ─── Table ─── */
.cgip-table-wrap {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.cgip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.cgip-table thead tr {
  background: #f8f9fa;
  border-bottom: 2px solid #e5e7eb;
}

.cgip-table th {
  padding: 10px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.5px;
  color: #6b7280;
  text-transform: uppercase;
  white-space: nowrap;
}

.cgip-table td {
  padding: 12px 16px;
  color: #374151;
  border-bottom: 1px solid #f3f4f6;
}

.cgip-table tbody tr:hover {
  background: #f9fafb;
}

.cgip-table .cgip-row-last td {
  border-bottom: none;
}

.cgip-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-family: "SF Mono", "Menlo", monospace;
  font-size: 13px;
}

.cgip-action {
  text-align: center;
  width: 100px;
}

.cgip-product-name {
  font-weight: 600;
  color: #1f2937;
}

.cgip-warehouse {
  color: #6b7280;
  font-size: 12px;
}

.cgip-cancel-btn {
  font-size: 12px !important;
  padding: 4px 12px !important;
}
</style>
